import React from 'react'
import ReactDOM from 'react-dom'

import CampaignBadge from 'components/CampaignBadge/CampaignBadge'
import useEffectOnce from 'hooks/useEffectOnce'

interface CmsBannerProps {
  design:
    | 'dark-red'
    | 'red'
    | 'green'
    | 'dark-gold'
    | 'dark-rainbow'
    | 'rainbow'
  pushToTop: boolean
  headline: string
  markets: string[]
  startTime: string
  endTime: string
  countdownTime: string
  linkPath: string
}

const CmsBanner: React.FC<CmsBannerProps> = ({
  design,
  pushToTop,
  headline,
  markets,
  startTime,
  endTime,
  countdownTime,
  linkPath,
}) => {
  const [isDomReady, setDomReady] = React.useState(false)

  useEffectOnce(() => {
    setDomReady(true)
  })

  const banner = (
    <CampaignBadge
      startTime={startTime}
      endTime={endTime}
      countdownTime={countdownTime}
      marketIds={markets}
      headline={headline}
      design={design}
      linkPath={linkPath}
    />
  )

  if (!pushToTop) {
    return banner
  }

  if (!isDomReady) {
    return null
  }
  const bannerRoot = document.getElementById('bannerRoot')
  return ReactDOM.createPortal(banner, bannerRoot)
}

export default CmsBanner
